.aboutWrapper {
  max-width: 500px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
